export default function redirectToWelcomePage(
  refererUrl: string,
  accessToken: string,
  email: string
) {
  location.href = `${WELCOME_PAGE_REDIRECTION_URL}/?email=${email}&accessToken=${accessToken}&referer=${encodeURIComponent(
    refererUrl
  )}`;
}
